import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";

export interface UseTreeStructureHookProps {
  showNodeDetailsPanel: boolean;
}

export const useTreeStructureHook = (): UseTreeStructureHookProps => {
  const nodeSelectionNodeState = useSelector(
    (state: RootState) => state.yourSlice.nodeSelection.state,
  );

  return {
    showNodeDetailsPanel: nodeSelectionNodeState !== "none",
  };
};
